import React, { useState, useEffect } from "react";
import "./HowToBuy.css";
import LeftSection from './LeftSection';
import RightSection from './RightSection';

const HowToBuy = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);

        const handleScroll = () => {
            const elements = document.querySelectorAll('.fade-in');
            elements.forEach(el => {
                const elementTop = el.getBoundingClientRect().top;
                const elementVisible = 150;
                if (elementTop < window.innerHeight - elementVisible) {
                    el.classList.add('active');
                }
            });
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="container-fluid p-0">
            <div className="row no-gutters">
                <div className="col-lg-2 col-md-3 col-12 leftcol">
                    <LeftSection />
                </div>
                <div className="col-lg-8 col-md-9 col-12 middlecol">
                    <div className={`how-to-buy-section ${isVisible ? 'visible' : ''}`}>
                        <div className="how-to-buy-content">
                            <div className="mainbox fade-in">
                                <div className="quote-icon">🚗</div>
                                <p className="mainsent">
                                    Your journey to owning a quality Japanese vehicle is simple, transparent, and secure with SKC Japan.
                                </p>
                            </div>

                            <div className="steps-container">
                                <div className="section-header center fade-in">
                                    <h2>Simple Steps – Your Path to Satisfaction</h2>
                                    <p>Follow these easy steps to purchase your perfect vehicle from Japan</p>
                                </div>

                                <div className="step-row">
                                    <div className="step-number fade-in">
                                        <div className="number-circle">1</div>
                                    </div>
                                    <div className="step-content fade-in">
                                        <h3>Choose Your Vehicle</h3>
                                        <p>Browse our stock and select the vehicle that suits your needs. You can filter by make, model, year, and more.</p>
                                        <div className="step-note">
                                            <p><strong>Can't find the vehicle you're looking for?</strong></p>
                                            <p>No problem—simply fill out the Inquiry Form with your requirements. Our sales team will respond promptly with available options.</p>
                                        </div>
                                    </div>
                                    <div className="step-visual fade-in">
                                        <div className="visual-box">
                                            <div className="visual-icon">🔍</div>
                                            <p>Browse Inventory</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="step-divider"></div>

                                <div className="step-row">
                                    <div className="step-number fade-in">
                                        <div className="number-circle">2</div>
                                    </div>
                                    <div className="step-content fade-in">
                                        <h3>Get a Quote & Place an Order</h3>
                                        <p>All prices listed on our website are FOB (Freight on Board). To receive a free quotation, fill out the Request Form with your contact details and vehicle specifications.</p>
                                        <p>After we confirm pricing (CIF/C&F/FOB), you will receive an invoice by email detailing:</p>
                                        <ul className="invoice-details">
                                            <li>Total cost</li>
                                            <li>Bank details</li>
                                            <li>Accepted payment methods</li>
                                        </ul>
                                        <div className="security-note">
                                            <div className="lock-icon">🔒</div>
                                            <p>Your information is used only for processing shipping and order documentation.</p>
                                        </div>
                                    </div>
                                    <div className="step-visual fade-in">
                                        <div className="visual-box">
                                            <div className="visual-icon">📋</div>
                                            <p>Request Quote</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="step-divider"></div>

                                <div className="step-row">
                                    <div className="step-number fade-in">
                                        <div className="number-circle">3</div>
                                    </div>
                                    <div className="step-content fade-in">
                                        <h3>Make Payment</h3>
                                        <p>You can choose from the following secure payment options:</p>
                                        <div className="payment-options">
                                            <div className="payment-method">
                                                <div className="method-icon">🏦</div>
                                                <div className="method-details">
                                                    <h4>Bank Transfer (Telegraphic Transfer)</h4>
                                                    <p>Send payment to S.K Co. Ltd's beneficiary account in Japan.</p>
                                                </div>
                                            </div>
                                            <div className="payment-method">
                                                <div className="method-icon">💳</div>
                                                <div className="method-details">
                                                    <h4>PayPal</h4>
                                                    <p>Request a PayPal-specific invoice from your sales representative to receive the PayPal account address.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="step-visual fade-in">
                                        <div className="visual-box">
                                            <div className="visual-icon">💰</div>
                                            <p>Secure Payment</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="step-divider"></div>

                                <div className="step-row">
                                    <div className="step-number fade-in">
                                        <div className="number-circle">4</div>
                                    </div>
                                    <div className="step-content fade-in">
                                        <h3>Shipment Confirmation</h3>
                                        <p>Once your payment is confirmed, we will schedule your shipment and notify you by email.</p>
                                        <div className="shipping-info">
                                            <div className="shipping-method">
                                                <div className="shipping-icon">🚢</div>
                                                <div className="shipping-details">
                                                    <h4>Sea Freight</h4>
                                                    <p>You'll receive ETD (Estimated Time of Departure) and ETA (Estimated Time of Arrival).</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="step-visual fade-in">
                                        <div className="visual-box">
                                            <div className="visual-icon">📦</div>
                                            <p>Shipping Process</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="step-divider"></div>

                                <div className="step-row">
                                    <div className="step-number fade-in">
                                        <div className="number-circle">5</div>
                                    </div>
                                    <div className="step-content fade-in">
                                        <h3>Customs Clearance & Delivery</h3>
                                        <p>When your vehicle arrives, complete the customs clearance procedures in your country.</p>
                                        <p>After that, your vehicle will be delivered to you.</p>
                                    </div>
                                    <div className="step-visual fade-in">
                                        <div className="visual-box">
                                            <div className="visual-icon">🏁</div>
                                            <p>Final Delivery</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="summary-section fade-in">
                                <div className="summary-card">
                                    <div className="summary-header">
                                        <h2>✅ Summary: Fast, Transparent, and Secure</h2>
                                    </div>
                                    <div className="summary-features">
                                        <div className="feature">
                                            <div className="feature-icon">✔️</div>
                                            <p>Wide selection of high-quality vehicles</p>
                                        </div>
                                        <div className="feature">
                                            <div className="feature-icon">✔️</div>
                                            <p>Easy quotation process</p>
                                        </div>
                                        <div className="feature">
                                            <div className="feature-icon">✔️</div>
                                            <p>Safe payment options</p>
                                        </div>
                                        <div className="feature">
                                            <div className="feature-icon">✔️</div>
                                            <p>Worldwide shipping</p>
                                        </div>
                                        <div className="feature">
                                            <div className="feature-icon">✔️</div>
                                            <p>Reliable after-sale support</p>
                                        </div>
                                    </div>
                                    <div className="cta-button">
                                        <button className="cta-primary">Start Your Purchase Now</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-2 col-12 rightcol">
                    <RightSection />
                </div>
            </div>
        </div>
    );
};

export default HowToBuy;